import { Icon, IconName, MixpanelEvent, useDisclosure, useMixpanel } from '@talos/kyoko';
import { useCallback } from 'react';
import { useFeatureFlag } from '../../hooks';
import { useIntercom } from '../../providers/IntercomContext';
import { envConfig } from '../../utils/envConfig';
import { SupportTicketDialog } from '../SupportTicket/SupportTicketDialog';
import { SidebarItem } from './SidebarItem';
import { PopoverMenu, PopoverMenuItem } from './styles';

export function SidebarHelpItem({ setExpanded }: { setExpanded: (expanded: boolean) => void }) {
  const supportTicketDialog = useDisclosure();
  const mixpanel = useMixpanel();
  const { enableSupportModal, showSupportChat } = useFeatureFlag();
  const handleSupportTicketClick = useCallback(() => {
    setExpanded(false);
    mixpanel.track(MixpanelEvent.SupportTicket);
    supportTicketDialog.open();
  }, [supportTicketDialog, mixpanel, setExpanded]);
  const { unreadCount } = useIntercom();

  return (
    <>
      <SidebarItem
        data-testid="sidebar-help-item"
        icon={IconName.Support}
        showIndicator={unreadCount > 0}
        menuItems={
          <PopoverMenu>
            {enableSupportModal && (
              <PopoverMenuItem onClick={handleSupportTicketClick}>
                <Icon icon={IconName.Ticket} />
                Support Ticket
              </PopoverMenuItem>
            )}
            {showSupportChat && (
              <PopoverMenuItem
                onClick={() => {
                  mixpanel.track(MixpanelEvent.Support);
                }}
                id="talos-intercom"
              >
                <Icon icon={IconName.Chat} />
                Support Chat
              </PopoverMenuItem>
            )}
            <PopoverMenuItem as="a" href={envConfig.VITE_KNOWLEDGE_BASE_URL} target="_blank">
              <Icon icon={IconName.BookOpen} />
              Knowledge Base
            </PopoverMenuItem>
          </PopoverMenu>
        }
      />
      <SupportTicketDialog dialog={supportTicketDialog} />
    </>
  );
}
